/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:18 GMT
 */
/* mixins & extensions */
/* helper to properly scale internal durations */
/**
* Currently only used in Checkbox.
*/
:host([disabled]) {
  cursor: default;
  -webkit-user-select: none;
          user-select: none;
  opacity: var(--calcite-opacity-disabled);
}

:host([disabled]) *,
:host([disabled]) ::slotted(*) {
  pointer-events: none;
}

:host {
  display: block;
}

:host([disabled]) ::slotted([calcite-hydrated][disabled]),
:host([disabled]) [calcite-hydrated][disabled] {
  /* prevent opacity stacking */
  opacity: 1;
}

.interaction-container {
  display: contents;
}

.container {
  position: relative;
}

.table-container {
  box-sizing: border-box;
  display: flex;
  inline-size: 100%;
  flex-direction: column;
  background-color: transparent;
}
.table-container * {
  box-sizing: border-box;
}

.table {
  inline-size: 100%;
  border-collapse: collapse;
}

.stack {
  --calcite-stack-padding-inline: 0;
  --calcite-stack-padding-block: 0;
}

.sticky-pos {
  position: sticky;
  inset-block-start: 0px;
  z-index: var(--calcite-z-index-sticky);
  background-color: var(--calcite-color-foreground-1);
}
.sticky-pos th {
  padding: 0px;
}

.assistive-text {
  position: absolute;
  inline-size: 1px;
  block-size: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

:host([hidden]) {
  display: none;
}

[hidden] {
  display: none;
}